// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ygnkE","searchIcon":"styles_searchIcon__12Kz3"};